import type { Mixpanel } from "mixpanel-browser";

let mixpanel: Promise<Mixpanel> | undefined;

// mixpanel-browser bundles its session recorder, more than half of the POS
// bundle: it downloads apart so the first screen doesn't wait for it.
export const initAnalytics = () => {
  mixpanel = import("mixpanel-browser").then(({ default: mixpanel }) => {
    mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
      track_pageview: true,
      persistence: "localStorage",
      record_sessions_percent: 100,
      record_heatmap_data: true,
    });
    return mixpanel;
  });
};

export const sendEvent = (eventName: string, properties?: any) => {
  mixpanel?.then((mixpanel) =>
    mixpanel.track(eventName, {
      ...properties,
      source: "pos",
    }),
  );
};
